import React, { Component, useMemo } from "react";
import MapContainer from "../../components/Dashboard/Dashboard_map";
import myConfig from "../../configs/config";
import axios from "axios";
import { getErrorComponent, getFormatedDate, buildUtcFromToParams } from "../../helpers/utils";
import { withTranslation } from "react-i18next";
import PoupUp from "../../components/PoupUp";
import KpisGadgets from "./KpiGadgets";
import "./DashboardPhone.css";
import { Link } from "react-router-dom";
import { FaCompress, FaExpand, FaMapMarkedAlt, FaPlus } from "react-icons/fa";
import FieldAppTimezoneToggle from "../FieldApp/FieldAppTimezoneToggle";
import MapIconColorLegend from "../../components/Dashboard/MapIconColorLegend";
import DashboardQuickMeasure from "../../components/Dashboard/DashboardQuickMeasure";
import {
  readTrackingTimezoneMode,
  writeTrackingTimezoneMode,
} from "../FieldApp/fieldAppTimezoneDisplay";
import { FloatingWhatsApp } from "@carlos8a/react-whatsapp-floating-button";
import DashboardHourlyForecastBar from "../../components/Dashboard/DashboardHourlyForecastBar";
import DashboardDailyForecastColumn from "../../components/Dashboard/DashboardDailyForecastColumn";
import DashboardWindArrow from "../../components/Dashboard/DashboardWindArrow";
import DashboardTracePanel from "./DashboardTracePanel";
import DashboardTraceColorControl from "./DashboardTraceColorControl";
import {
  ensureOperatorTraceColors,
  readOperatorTraceColors,
  setOperatorTraceColor,
  subscribeOperatorTraceColors,
} from "./operatorTraceColors";
import "../../components/Dashboard/DraggableMapControl.css";
import {
  appendMovedPoint,
  appendOperatorTrailSegments,
  buildOperatorMapState,
  countTracePoints,
  flattenPathReportToTraces,
  flattenTrailSegments,
  DEFAULT_TRACE_HOURS,
  getDefaultTracePeriod,
  getTracePeriodForHours,
  openTracePeriod,
  latestPositionsByOperator,
  MAX_FENCE_TRACE_PERIOD_MS,
  MAX_TRACE_PERIOD_MS,
  pointInsideLandplots,
  splitPathByTeleport,
  validateTracePeriod,
} from "./dashboardTraceUtils";
import {
  MAX_PEOPLE_TRACE_PERIOD_MS,
  activeTrailChip,
  periodForTrailDayKeys,
  readTrailRoster,
  stampOnTrailDays,
  trailHourKey,
  toggleTrailDayKeys,
  toggleTrailPeriodKey,
  trailsToDraw,
  writeTrailRoster,
} from "./dashboardTrailPeople";
import { mergeTrailOperations } from "./dashboardTrailWork";
import { usePendingSchedules } from "../../contexts/PendingSchedulesContext";
import {
  assumedMachineIdentSet,
  applyLiveTelemetryToAssumedMachines,
  applyParkedMachinePositions,
  attachActiveTelemetryOperators,
  rememberParkedMachines,
  getEquipmentPathPoints,
  isValidEquipmentCoordinate,
  lastValidCoordinate,
  resolveEquipmentMarkerPosition,
} from "./dashboardMapUtils";
import {
  nextLastMovedAt,
  TELEMETRY_RELEASE_GREEN_MS,
  TELEMETRY_RELEASE_YELLOW_MS,
} from "./dashboardIconTone";
import { fetchActiveTelemetry } from "../FieldApp/fieldAppApi";
import {
  machineTelemetryReleaseKey,
  mergeTelemetryReleases,
  nextTelemetryReleases,
  operatorTelemetryReleaseKey,
  readReleaseEntry,
  applyIconMachinePairing,
  applySessionLastMachine,
  releaseFieldsFromEntry,
  telemetryReleasesFromApi,
} from "./dashboardActiveTelemetry";
import DashboardFieldAlertPopup from "./DashboardFieldAlertPopup";
import {
  detectFieldAlertEvents,
  fieldAlertDurationMs,
  filterEnabledFieldAlerts,
  loadFieldAlertPrefs,
  saveFieldAlertPrefs,
  shouldShowFieldAlertDesktop,
  showFieldAlertDesktopNotification,
} from "./dashboardFieldAlerts";
import { isIdleReserveMachine } from "../Machine/machineVisibility";
import { ToastContainer } from "react-toastify";

function dashboardMapHeightKey(farmId) {
  return `dashboard-map-height-${farmId}`;
}

function dashboardCleanKey(farmId) {
  return `dashboard-map-clean-${farmId}`;
}

function DashboardMapOrders({ children }) {
  const { pendingObs, completedObs, refreshPending } = usePendingSchedules();
  const orders = useMemo(
    () => [...(pendingObs || []), ...(completedObs || [])],
    [pendingObs, completedObs]
  );
  return children(orders, refreshPending);
}

function traceColorModeKey(farmId) {
  return `dashboard-trace-color-mode-${farmId}`;
}

function traceSpeedKey(farmId) {
  return `dashboard-trace-speed-${farmId}`;
}

function readTraceColorMode(farmId) {
  try {
    return window.localStorage.getItem(traceColorModeKey(farmId)) === "speed"
      ? "speed"
      : "machine";
  } catch (error) {
    return "machine";
  }
}

function readTraceSpeed(farmId) {
  try {
    const raw = Number(window.localStorage.getItem(traceSpeedKey(farmId)));
    if (Number.isFinite(raw) && raw >= 1 && raw <= 120) return raw;
  } catch (error) {
    // ignore
  }
  return 15;
}

function traceSpeedsKey(farmId) {
  return `dashboard-trace-speeds-${farmId}`;
}

function traceSpeedIndexKey(farmId) {
  return `dashboard-trace-speed-index-${farmId}`;
}

function clampTraceSpeed(value) {
  const speed = Number(value);
  if (!Number.isFinite(speed) || speed < 1 || speed > 120) return null;
  return speed;
}

function readTraceSpeedPresets(farmId) {
  try {
    const raw = JSON.parse(window.localStorage.getItem(traceSpeedsKey(farmId)));
    if (Array.isArray(raw) && raw.length === 3) {
      const speeds = raw.map(clampTraceSpeed);
      if (speeds.every((speed) => speed != null)) {
        const indexRaw = Number(
          window.localStorage.getItem(traceSpeedIndexKey(farmId))
        );
        const index = indexRaw >= 0 && indexRaw < speeds.length ? indexRaw : 0;
        return { speeds, index };
      }
    }
  } catch (error) {
    // ignore
  }
  return { speeds: [readTraceSpeed(farmId), 15, 25], index: 0 };
}

function writeTraceSpeedPresets(farmId, speeds, index) {
  try {
    window.localStorage.setItem(traceSpeedsKey(farmId), JSON.stringify(speeds));
    window.localStorage.setItem(traceSpeedIndexKey(farmId), String(index));
    window.localStorage.setItem(traceSpeedKey(farmId), String(speeds[index]));
  } catch (error) {
    // ignore
  }
}

function linesForQuickMeasure(equipment, operators) {
  const lines = [];
  Object.values(equipment || {}).forEach((item) => {
    splitPathByTeleport(getEquipmentPathPoints(item)).forEach((segment) => {
      if (segment && segment.length >= 2) lines.push({ path: segment });
    });
  });
  Object.values(operators || {}).forEach((operator) => {
    const segments =
      operator.last_posi_segments && operator.last_posi_segments.length
        ? operator.last_posi_segments
        : [operator.last_posi_point || []];
    segments.forEach((segment) => {
      const path = (segment || []).filter(
        (point) => point && point.lat != null && point.lng != null
      );
      if (path.length >= 2) lines.push({ path });
    });
  });
  return lines;
}

function defaultDashboardMapHeight() {
  return Math.max(640, window.innerHeight - 180);
}

const PHONE_DESKTOP_WIDTH = 1024;

function readPhoneDashboardScale() {
  if (typeof window === "undefined" || window.innerWidth >= 600) return 1;
  const available = Math.max(280, window.innerWidth - 20);
  return available / PHONE_DESKTOP_WIDTH;
}

function phoneMapHeight(scale) {
  const header = 64;
  const aboveMap = 230;
  const visual = Math.max(520, window.innerHeight - header);
  return Math.max(640, Math.round(visual / scale - aboveMap));
}

function readDashboardMapHeight(farmId) {
  try {
    const raw = Number(window.localStorage.getItem(dashboardMapHeightKey(farmId)));
    if (Number.isFinite(raw) && raw >= 360) {
      return Math.min(raw, window.innerHeight - 40);
    }
  } catch (error) {
    // ignore
  }
  return defaultDashboardMapHeight();
}

function readDashboardClean(farmId) {
  try {
    return window.localStorage.getItem(dashboardCleanKey(farmId)) === "1";
  } catch (error) {
    return false;
  }
}

class Home extends Component {
  farmId = this.props.match.params.farm_id;

  FARM_URL = `${myConfig.API_URL}/farm/${this.farmId}/`;
  LANDPLOT_URL = `${myConfig.API_URL}/landplot/?farm_id=${this.farmId}`;
  MARKERS_URL = `${myConfig.API_URL}/equipment/equipments_info/?farm_id=${this.farmId}`;

  constructor(props) {
    super(props);
    const defaultTracePeriod = getDefaultTracePeriod();
    const traceSpeedPresets = readTraceSpeedPresets(this.farmId);

    this.state = {
      loading: true,
      map: {},
      online_machines: "",
      weather_data: [],
      errors: [],
      farm: [],
      landplot: [],
      equipment: {},
      operators: {},
      marker_center: [],
      mapZoom: 0,
      modal: false,
      modalOperation: false,
      modalHoursIdle: false,
      kpi_data: [],
      periods: [],
      kpiOperations: [],
      kpiMachines: [],
      kpiReports: [],
      kpiIdle: [],
      period_id: 0,
      operations: [],
      trailOperations: [],
      tracePanelOpen: false,
      traceMode: "historical",
      tracePresetHours: DEFAULT_TRACE_HOURS,
      tracePeriodStart: defaultTracePeriod.start,
      tracePeriodEnd: defaultTracePeriod.end,
      selectedLandplots: [],
      landplotPickMode: false,
      traceColorMode: readTraceColorMode(this.farmId),
      traceSpeeds: traceSpeedPresets.speeds,
      traceSpeedIndex: traceSpeedPresets.index,
      traceSpeedKmh: traceSpeedPresets.speeds[traceSpeedPresets.index],
      operatorTraceColors: readOperatorTraceColors(this.farmId),
      traceLoading: false,
      traceError: "",
      historicalTracesLoaded: false,
      cleanMode: readDashboardClean(this.farmId),
      phoneScale: readPhoneDashboardScale(),
      mapHeight:
        readPhoneDashboardScale() < 1
          ? phoneMapHeight(readPhoneDashboardScale())
          : readDashboardMapHeight(this.farmId),
      weatherCenter: null,
      windDeg: null,
      telemetrySessions: [],
      telemetryReleases: {},
      parkedMachines: {},
      fieldAlertPrefs: loadFieldAlertPrefs(),
      visibleTrailOperatorIds: null,
      visibleTrailMachineIdents: null,
      trailRoster: readTrailRoster(this.farmId),
      mapTrailMode: "people",
      trailDayKeys: [],
      trailNoticeOpen: false,
      activeTraceHours: 12,
      activeTelemetryOperatorIds: [],
      fieldAlertCurrent: null,
      fieldAlertQueue: [],
      timezoneMode: readTrackingTimezoneMode(this.farmId),
      nativeMap: null,
      nativeMaps: null,
    };
    this._fieldAlertsPrimed = false;
    this.handleMapLoaded = this.handleMapLoaded.bind(this);
    this.saveMapViewport = null;
  }

  handleViewportActionsReady = (actions) => {
    this.saveMapViewport = actions && actions.save ? actions.save : null;
  };

  handleSaveMapViewportClick = () => {
    if (this.saveMapViewport) {
      this.saveMapViewport();
    }
  };

  handleTimezoneModeChange = (mode) => {
    writeTrackingTimezoneMode(this.farmId, mode);
    this.setState({ timezoneMode: mode });
  };

  handleNativeMapReady = ({ map, maps }) => {
    if (this.state.nativeMap === map) return;
    this.setState({ nativeMap: map, nativeMaps: maps });
  };

  applyCleanBodyClass(cleanMode) {
    document.body.classList.toggle("dashboard-map-clean-mode", Boolean(cleanMode));
  }

  componentDidMount() {
    this.applyCleanBodyClass(this.state.cleanMode);
    document.addEventListener("visibilitychange", this.handleDashboardWake);
    window.addEventListener("focus", this.handleDashboardWake);
    window.addEventListener("resize", this.handlePhoneScale);
    this.unsubscribeOperatorColors = subscribeOperatorTraceColors((colors) => {
      if (this._unmounted) return;
      this.setState({ operatorTraceColors: colors });
    });
  }

  componentDidUpdate() {
    this.syncOperatorTraceColors();
  }

  syncOperatorTraceColors() {
    const ids = [];
    (this.state.telemetrySessions || []).forEach((session) => {
      if (session && session.operatorId != null && session.operatorId !== "") {
        ids.push(session.operatorId);
      }
    });
    Object.keys(this.state.operators || {}).forEach((id) => ids.push(id));
    ensureOperatorTraceColors(this.farmId, ids);
  }

  handleOperatorTraceColor = (operatorId, color) => {
    setOperatorTraceColor(this.farmId, operatorId, color);
  };

  handlePhoneScale = () => {
    const phoneScale = readPhoneDashboardScale();
    if (phoneScale === this.state.phoneScale) return;
    this.setState({
      phoneScale,
      mapHeight:
        phoneScale < 1 ? phoneMapHeight(phoneScale) : this.state.mapHeight,
    });
  };

  componentWillUnmount() {
    this._unmounted = true;
    window.removeEventListener("resize", this.handlePhoneScale);
    if (this.unsubscribeOperatorColors) {
      this.unsubscribeOperatorColors();
    }
    if (this.markersPollTimer) {
      clearTimeout(this.markersPollTimer);
    }
    if (this.telemetryPollTimer) {
      clearTimeout(this.telemetryPollTimer);
    }
    if (this.fieldAlertTimer) {
      clearTimeout(this.fieldAlertTimer);
      this.fieldAlertTimer = null;
    }
    if (this._tracesTimer) {
      clearTimeout(this._tracesTimer);
      this._tracesTimer = null;
    }
    if (this._liveTraceTimer) {
      clearTimeout(this._liveTraceTimer);
      this._liveTraceTimer = null;
    }
    this._tracesRequestId = (this._tracesRequestId || 0) + 1;
    (this.telemetryReleaseTimers || []).forEach((timer) => clearTimeout(timer));
    this.telemetryReleaseTimers = [];
    document.removeEventListener("visibilitychange", this.handleDashboardWake);
    window.removeEventListener("focus", this.handleDashboardWake);
    document.body.classList.remove("dashboard-map-clean-mode");
  }

  handleDashboardWake = () => {
    if (this._unmounted) return;
    if (typeof document !== "undefined" && document.visibilityState === "hidden") {
      return;
    }
    const now = Date.now();
    if (this._lastDashboardWakeAt && now - this._lastDashboardWakeAt < 2000) {
      return;
    }
    this._lastDashboardWakeAt = now;
    this.load_markers_data();
    this.loadTelemetrySessions();
  };

  persistMapHeight = (height) => {
    const value = height != null ? height : this.state.mapHeight;
    try {
      window.localStorage.setItem(
        dashboardMapHeightKey(this.farmId),
        String(value)
      );
    } catch (error) {
      // ignore
    }
  };

  toggleCleanMode = () => {
    this.setState((prevState) => {
      const cleanMode = !prevState.cleanMode;
      try {
        window.localStorage.setItem(
          dashboardCleanKey(this.farmId),
          cleanMode ? "1" : "0"
        );
      } catch (error) {
        // ignore
      }
      this.applyCleanBodyClass(cleanMode);
      return { cleanMode };
    });
  };

  handleMapHeightResize = (event) => {
    event.preventDefault();
    const startY = event.clientY;
    const startHeight = this.state.mapHeight;
    let latest = startHeight;
    const onMove = (moveEvent) => {
      latest = Math.max(
        360,
        Math.min(window.innerHeight - 40, startHeight + (moveEvent.clientY - startY))
      );
      this.setState({ mapHeight: latest });
    };
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      this.persistMapHeight(latest);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  };

  handleModal = () => {
    const { modal } = this.state;

    this.setState({ modal: !modal });
  };

  handleModalOperation = () => {
    this.setState((prev) => ({ modalOperation: !prev.modalOperation }));
  };

  handleModalHoursIdle = () => {
    // console.log("handleModalHoursIdle");
    const { modalHoursIdle } = this.state;

    this.setState({ modalHoursIdle: !modalHoursIdle });
  };

  handleFieldAlertPrefsChange = (prefs) => {
    saveFieldAlertPrefs(prefs);
    this.setState({ fieldAlertPrefs: prefs });
  };

  handleVisibleTrailOperators = (visibleTrailOperatorIds) => {
    this.setState({ visibleTrailOperatorIds, mapTrailMode: "people" });
  };

  handleVisibleTrailMachines = (visibleTrailMachineIdents) => {
    this.setState({ visibleTrailMachineIdents, mapTrailMode: "people" });
  };

  handleTrailRoster = (trailRoster) => {
    const next = {
      operatorIds: Array.isArray(trailRoster && trailRoster.operatorIds)
        ? trailRoster.operatorIds
        : null,
      machineIdents: Array.isArray(trailRoster && trailRoster.machineIdents)
        ? trailRoster.machineIdents
        : null,
    };
    writeTrailRoster(this.farmId, next);
    this.setState({ trailRoster: next, mapTrailMode: "people" });
  };

  handleSelectPeopleTrails = () => {
    this.setState({ mapTrailMode: "people", trailNoticeOpen: true });
  };

  handleCloseTrailNotice = () => {
    this.setState({ trailNoticeOpen: false });
  };

  handleApplyPeopleTrailPeriod = (start, end) => {
    this.setState(
      {
        mapTrailMode: "people",
        tracePeriodStart: start,
        tracePeriodEnd: end,
        tracePresetHours: Math.max(1, Math.round((end - start) / (60 * 60 * 1000))),
        traceError: "",
        trailDayKeys: [],
        trailNoticeOpen: false,
      },
      () => this.loadDashboardTraces()
    );
  };

  applyTrailPeriodKeys = (trailDayKeys) => {
    if (!trailDayKeys.length) {
      const period = getTracePeriodForHours(12);
      return {
        trailDayKeys,
        mapTrailMode: "people",
        tracePeriodStart: period.start,
        tracePeriodEnd: period.end,
        tracePresetHours: 12,
        traceError: "",
        trailNoticeOpen: false,
      };
    }
    const period = periodForTrailDayKeys(trailDayKeys);
    if (!period) {
      const fallback = getTracePeriodForHours(12);
      return {
        trailDayKeys: [],
        mapTrailMode: "people",
        tracePeriodStart: fallback.start,
        tracePeriodEnd: fallback.end,
        tracePresetHours: 12,
        traceError: "",
        trailNoticeOpen: false,
      };
    }
    return {
      trailDayKeys,
      mapTrailMode: "people",
      tracePeriodStart: period.start,
      tracePeriodEnd: period.end,
      tracePresetHours: Math.max(
        1,
        Math.round((period.end - period.start) / (60 * 60 * 1000))
      ),
      traceError: "",
      trailNoticeOpen: false,
    };
  };

  seedTrailKeysFromPeriod(prev) {
    const keys = Array.isArray(prev.trailDayKeys) ? prev.trailDayKeys.slice() : [];
    if (keys.length) return keys;
    const chip = activeTrailChip(prev.tracePeriodStart, prev.tracePeriodEnd);
    if (chip === "1h" || chip === "12h") return [chip];
    return keys;
  }

  handleToggleTrailDay = (date) => {
    this.setState((prev) => {
      const seeded = this.seedTrailKeysFromPeriod(prev);
      return this.applyTrailPeriodKeys(toggleTrailDayKeys(seeded, date));
    }, () => this.loadDashboardTraces());
  };

  handleToggleTrailHour = (hours) => {
    const key = trailHourKey(hours);
    if (!key) return;
    this.setState((prev) => {
      const seeded = this.seedTrailKeysFromPeriod(prev);
      return this.applyTrailPeriodKeys(toggleTrailPeriodKey(seeded, key));
    }, () => this.loadDashboardTraces());
  };

  handleSelectActiveTrails = () => {
    const hours = Number(this.state.activeTraceHours) || 12;
    const period = getTracePeriodForHours(hours);
    this.setState(
      {
        mapTrailMode: "active",
        trailNoticeOpen: false,
        tracePeriodStart: period.start,
        tracePeriodEnd: period.end,
        tracePresetHours: hours,
        traceError: "",
      },
      () => this.loadDashboardTraces()
    );
  };

  handleActiveTraceHours = (hours) => {
    const nextHours = Number(hours) || 12;
    const period = getTracePeriodForHours(nextHours);
    this.setState(
      {
        mapTrailMode: "active",
        activeTraceHours: nextHours,
        tracePeriodStart: period.start,
        tracePeriodEnd: period.end,
        tracePresetHours: nextHours,
        traceError: "",
      },
      () => this.loadDashboardTraces()
    );
  };

  handleActiveTelemetrySessions = (sessions) => {
    const ids = (sessions || []).map((session) => String(session.operatorId));
    const current = this.state.activeTelemetryOperatorIds || [];
    if (ids.join(",") === current.join(",")) return;
    this.setState({ activeTelemetryOperatorIds: ids });
  };

  handleIncomingRadio = () => {
    if (this._unmounted) return;
    this.setState((prev) => {
      if (!prev.fieldAlertPrefs.radio) return null;
      const incoming = [{ type: "radio" }];
      if (prev.fieldAlertCurrent) {
        return { fieldAlertQueue: prev.fieldAlertQueue.concat(incoming) };
      }
      return {
        fieldAlertCurrent: incoming[0],
        fieldAlertQueue: prev.fieldAlertQueue,
      };
    }, this.scheduleFieldAlertDismiss);
  };

  scheduleFieldAlertDismiss = () => {
    if (this._unmounted || this.fieldAlertTimer || !this.state.fieldAlertCurrent) {
      return;
    }
    if (
      shouldShowFieldAlertDesktop(
        this.state.fieldAlertPrefs,
        document.hasFocus()
      )
    ) {
      showFieldAlertDesktopNotification(
        this.state.fieldAlertCurrent,
        this.props.t
      );
    }
    this.fieldAlertTimer = setTimeout(() => {
      this.fieldAlertTimer = null;
      if (this._unmounted) return;
      this.setState((prev) => {
        const [next, ...rest] = prev.fieldAlertQueue;
        return {
          fieldAlertCurrent: next || null,
          fieldAlertQueue: rest,
        };
      }, this.scheduleFieldAlertDismiss);
    }, fieldAlertDurationMs(this.state.fieldAlertPrefs));
  };

  handleMapLoaded(e, colors) {
    if (this.state.mapLoaded === false) {
      this.setState({
        line_color: colors,
        mapLoaded: true,
      });
    }
  }

  same_position(last_posi, new_posi) {
    if (last_posi.lat !== new_posi.lat) {
      if (last_posi.lng !== new_posi.lng) {
        return false;
      }
    }

    return true;
  }

  onZoomChanged = () => {
    if (!this.state.marker_center || !this.state.marker_center.length) return;
    this.setState({
      marker_center: [],
    });
  };

  handleMapCenterChanged = (center) => {
    if (!center || !Number.isFinite(center.lat) || !Number.isFinite(center.lng)) {
      return;
    }
    const prev = this.state.weatherCenter;
    if (
      prev &&
      Math.abs(prev.lat - center.lat) < 0.0008 &&
      Math.abs(prev.lng - center.lng) < 0.0008
    ) {
      return;
    }
    this.setState({ weatherCenter: center });
  };

  handleWindChange = (windDeg) => {
    const next = Number(windDeg);
    if (!Number.isFinite(next)) return;
    if (this.state.windDeg === next) return;
    this.setState({ windDeg: next });
  };

  load_markers_data() {
    axios({
      baseURL: this.MARKERS_URL,
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
    })
      // axios.get(this.MARKERS_URL)
      .then((res) => {
        let response = res.data;
        if (res.status === 200) {
          let equipment_data = {};

          for (let i = 0; i < response.length; i++) {
            if (isIdleReserveMachine(response[i])) {
              continue;
            }

            const previous = this.state.equipment[response[i].id];
            const previousPoints =
              previous && previous.last_posi_point
                ? previous.last_posi_point
                : [];
            const previousPosition = previous
              ? resolveEquipmentMarkerPosition(previous).position
              : null;

            equipment_data[response[i].id] = {
              id: response[i].id,
              ident: response[i].ident,
              farm: response[i].farm,
              farm_name: response[i].farm_name,
              category: response[i].category,
              marca: response[i].marca,
              category_name: response[i].category_name,
              sub_category: response[i].sub_category,
              subcategory_name: response[i].subcategory_name,
              capacity: response[i].capacity,
              manufacture_year: response[i].manufacture_year,
              classification: response[i].classification,
              manufacturer: response[i].manufacturer,
              device_uid: response[i].device_uid,
              machine_status: response[i].machine_status,
              traccar_ico: response[i].traccar_ico,
              speed: response[i].speed,
              last_connection: response[i].last_connection,
              operation: response[i].operation,
              operator_label: response[i].operator_label,
              last_posi_point: previousPoints,
              lastMovedAt: previous && previous.lastMovedAt,
              extra_inf: response[i].extra_inf,
            };

            const lastPoint = response[i].last_posi_point;
            if (!isValidEquipmentCoordinate(lastPoint)) {
              continue;
            }

            const newPoint = {
              lat: lastPoint.lat,
              lng: lastPoint.lng,
            };

            equipment_data[response[i].id]["last_posi_point"] = appendMovedPoint(
              previousPoints,
              newPoint
            );
            equipment_data[response[i].id]["lastMovedAt"] = nextLastMovedAt({
              previousMovedAt: previous && previous.lastMovedAt,
              previousPosition,
              nextPosition: newPoint,
              fallbackAt: response[i].last_connection,
            });
          }

          this.setState(
            {
              equipment: equipment_data,
            },
            () => {
              if (!this._initialTracesRequested) {
                this._initialTracesRequested = true;
                this._tracesTimer = setTimeout(() => {
                  this.loadDashboardTraces();
                }, 1200);
              }
              this.scheduleLiveTraceRefresh();
            }
          );

          this.scheduleMarkersPoll();
          this.refreshOperatorLastKnown();
          this.loadTelemetrySessions();
        } else {
          this.setState({
            errors: this.state.errors.concat(
              getErrorComponent(res.data.detail)
            ),
          });
        }
      })
      .catch(() => {
        this.scheduleMarkersPoll();
      });
  }

  async loadTelemetrySessions() {
    if (this._unmounted) return;
    try {
      const data = await fetchActiveTelemetry(this.farmId);
      const sessions = (data && data.sessions) || [];
      const apiReleases = telemetryReleasesFromApi(data && data.releases);
      if (this._unmounted) return;
      this.setState(
        (prev) => {
          const telemetryReleases = mergeTelemetryReleases(
            nextTelemetryReleases({
              previousSessions: prev.telemetrySessions,
              nextSessions: sessions,
              previousReleases: prev.telemetryReleases,
            }),
            apiReleases
          );
          const incoming = filterEnabledFieldAlerts(
            detectFieldAlertEvents({
              previousSessions: prev.telemetrySessions,
              nextSessions: sessions,
              previousReleases: prev.telemetryReleases,
              nextReleases: telemetryReleases,
              primed: this._fieldAlertsPrimed,
            }),
            prev.fieldAlertPrefs
          );
          this._fieldAlertsPrimed = true;
          const nextAlert = incoming.length
            ? prev.fieldAlertCurrent
              ? {
                  fieldAlertQueue: prev.fieldAlertQueue.concat(incoming),
                }
              : {
                  fieldAlertCurrent: incoming[0],
                  fieldAlertQueue: prev.fieldAlertQueue.concat(incoming.slice(1)),
                }
            : {};
          return {
            telemetrySessions: sessions,
            telemetryReleases,
            parkedMachines: rememberParkedMachines(
              prev.parkedMachines,
              sessions,
              prev.operators
            ),
            ...nextAlert,
          };
        },
        () => {
          this.refreshOperatorLastKnown();
          this.scheduleFieldAlertDismiss();
          this.scheduleTelemetryReleaseTicks();
          this.scheduleTelemetryPoll();
        }
      );
    } catch (error) {
      if (!this._unmounted) {
        this.scheduleTelemetryPoll();
      }
    }
  }

  scheduleTelemetryPoll() {
    if (this._unmounted) return;
    if (this.telemetryPollTimer) {
      clearTimeout(this.telemetryPollTimer);
    }
    this.telemetryPollTimer = setTimeout(() => {
      this.loadTelemetrySessions();
    }, 5000);
  }

  scheduleTelemetryReleaseTicks() {
    if (this._unmounted) return;
    (this.telemetryReleaseTimers || []).forEach((timer) => clearTimeout(timer));
    this.telemetryReleaseTimers = [];
    const now = Date.now();
    Object.values(this.state.telemetryReleases || {}).forEach((stamp) => {
      const entry = readReleaseEntry(stamp);
      const releasedMs = entry ? new Date(entry.at).getTime() : NaN;
      if (Number.isNaN(releasedMs)) return;
      [TELEMETRY_RELEASE_GREEN_MS, TELEMETRY_RELEASE_YELLOW_MS].forEach((delay) => {
        const wait = releasedMs + delay - now;
        if (wait <= 0) return;
        this.telemetryReleaseTimers.push(
          setTimeout(() => {
            if (this._unmounted) return;
            this.setState({ telemetryReleaseTick: Date.now() });
          }, wait)
        );
      });
    });
  }

  scheduleLiveTraceRefresh() {
    if (this._unmounted || this._liveTraceTimer) return;
    this._liveTraceTimer = setTimeout(() => {
      this._liveTraceTimer = null;
      if (this._unmounted) return;
      if (!this._traceRefreshInFlight) {
        this.loadDashboardTraces({ quiet: true });
      }
      this.scheduleLiveTraceRefresh();
    }, 10000);
  }

  scheduleMarkersPoll() {
    if (this._unmounted) return;
    if (this.markersPollTimer) {
      clearTimeout(this.markersPollTimer);
    }
    this.markersPollTimer = setTimeout(() => {
      this.load_markers_data();
    }, 10000);
  }

  load_landplot_data() {
    axios({
      baseURL: this.LANDPLOT_URL,
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
    })
      .then((res) => {
        let landplot = res.data;
        if (res.status === 200) {
          this.setState({
            landplot: landplot,
          });
        } else {
          this.setState({
            errors: this.state.errors.concat(
              getErrorComponent(res.data.detail)
            ),
          });
        }
      })
      .catch((error) => {
        // console.log(error);
        alert(
          "Falha ao carregar talhões, recarregue a página ou tente novamente mais tarde"
        );
      });
  }

  async fetchKpis() {
    let { farm } = this.state;

    try {
      const KPI_URL = `${myConfig.API_URL}/dashboard/?farm_id=${this.farmId}`;

      let response = await axios({
        baseURL: KPI_URL,
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      });

      const kpi = await response.data;

      if (response.status === 200) {
        this.setState({
          periods: kpi.idle_info,
          kpi_data: kpi,
          map: {
            centroidLat: farm.latitude.toString().replace(",", "."),
            centroidLng: farm.longitude.toString().replace(",", "."),
          },
        });

        if (window.location.pathname.length < 6) {
          setTimeout(this.fetchKpis.bind(this), 10000);
        }
      }
    } catch (err) {
      if (!this._unmounted) {
        this.setState({ loading: false });
      }
    }
  }

  setPeriod = (period) => {
    // console.log("period ***", period);
    this.setState({
      period_id: period,
    });
  };

  handleTraceColorMode = (mode) => {
    const next = mode === "speed" ? "speed" : "machine";
    this.setState({ traceColorMode: next });
    try {
      window.localStorage.setItem(traceColorModeKey(this.farmId), next);
    } catch (error) {
      // ignore
    }
  };

  handleTraceSpeedSelect = (index) => {
    const speeds = this.state.traceSpeeds || [];
    const speed = speeds[index];
    if (speed == null) return;
    this.setState({ traceSpeedIndex: index, traceSpeedKmh: speed });
    writeTraceSpeedPresets(this.farmId, speeds, index);
  };

  handleTraceSpeedChange = (index, value) => {
    const speed = clampTraceSpeed(value);
    if (speed == null) return;
    const traceSpeeds = (this.state.traceSpeeds || []).slice();
    traceSpeeds[index] = speed;
    const active = index === this.state.traceSpeedIndex;
    this.setState({
      traceSpeeds,
      traceSpeedKmh: active ? speed : this.state.traceSpeedKmh,
    });
    writeTraceSpeedPresets(
      this.farmId,
      traceSpeeds,
      active ? index : this.state.traceSpeedIndex
    );
  };

  handleTracePanelToggle = () => {
    this.setState((prevState) => ({
      tracePanelOpen: !prevState.tracePanelOpen,
    }));
  };

  handleTracePresetHours = (hours) => {
    const fenceSelected = (this.state.selectedLandplots || []).length > 0;
    const maxHours = fenceSelected ? 24 * 7 : 24;
    const nextHours = Math.min(Number(hours) || 1, maxHours);
    const { start, end } = getTracePeriodForHours(nextHours);
    this.setState(
      {
        tracePeriodStart: start,
        tracePeriodEnd: end,
        tracePresetHours: nextHours,
        traceMode: "historical",
        traceError: "",
      },
      () => this.loadDashboardTraces()
    );
  };

  handleLandplotPickMode = (enabled) => {
    this.setState({ landplotPickMode: Boolean(enabled) });
  };

  handleToggleLandplotPickMode = () => {
    this.setState((prev) => ({ landplotPickMode: !prev.landplotPickMode }));
  };

  handleToggleLandplot = (landplot, options = {}) => {
    // Modo Talhão (ícone) = clique simples. Sem modo = só duplo clique / toque duplo.
    if (!options.fromDoubleClick && !this.state.landplotPickMode) return;
    if (!landplot || landplot.id == null) return;
    this.setState((prev) => {
      const current = prev.selectedLandplots || [];
      const exists = current.some(
        (item) => Number(item.id) === Number(landplot.id)
      );
      const selectedLandplots = exists
        ? current.filter((item) => Number(item.id) !== Number(landplot.id))
        : current.concat([
            {
              id: landplot.id,
              name: landplot.name,
              geomap: landplot.geomap,
            },
          ]);
      let tracePresetHours = prev.tracePresetHours;
      let tracePeriodStart = prev.tracePeriodStart;
      let tracePeriodEnd = prev.tracePeriodEnd;
      const trailDayKeys = prev.trailDayKeys || [];
      // Ao (re)marcar talhão, recalcula o período pelas chips já ligadas (1h/12h/dias).
      if (selectedLandplots.length > 0 && trailDayKeys.length > 0) {
        const period = periodForTrailDayKeys(trailDayKeys);
        if (period) {
          tracePeriodStart = period.start;
          tracePeriodEnd = period.end;
          tracePresetHours = Math.max(
            1,
            Math.round((period.end - period.start) / (60 * 60 * 1000))
          );
        }
      }
      return {
        selectedLandplots,
        tracePresetHours,
        tracePeriodStart,
        tracePeriodEnd,
        tracePanelOpen: true,
        mapTrailMode: "people",
      };
    }, () => this.loadDashboardTraces());
  };

  handleClearLandplots = () => {
    this.setState({
      selectedLandplots: [],
    }, () => this.loadDashboardTraces());
  };

  operatorAuthHeaders() {
    return {
      Authorization: `Bearer ${localStorage.getItem("client-token")}`,
    };
  }

  async fetchOperatorLastKnown() {
    try {
      const response = await axios({
        baseURL: `${myConfig.BE_URL}/api/operator/positions/?farm_id=${this.farmId}&latest=1`,
        method: "GET",
        headers: this.operatorAuthHeaders(),
      });
      const positions = response.data && response.data.positions;
      if (Array.isArray(positions) && positions.length > 0) {
        return latestPositionsByOperator(positions);
      }
    } catch (error) {
      return [];
    }
  }

  async fetchOperatorTrailPositions(start, end) {
    const { from, to } = buildUtcFromToParams(start, end);
    try {
      const response = await axios({
        baseURL: `${myConfig.BE_URL}/api/operator/positions/?farm_id=${this.farmId}&from=${encodeURIComponent(
          from
        )}&to=${encodeURIComponent(to)}&limit=${
          end - start > MAX_TRACE_PERIOD_MS ? 15000 : 5000
        }`,
        method: "GET",
        headers: this.operatorAuthHeaders(),
      });
      return (response.data && response.data.positions) || [];
    } catch (error) {
      return [];
    }
  }

  refreshOperatorLastKnown = async () => {
    if (this._unmounted) return;
    const lastKnown = await this.fetchOperatorLastKnown();
    if (this._unmounted || !Array.isArray(lastKnown) || lastKnown.length === 0) {
      return;
    }

    const opened = openTracePeriod(
      this.state.tracePeriodStart,
      this.state.tracePeriodEnd
    );
    const tracePeriodStart = opened.start;
    const tracePeriodEnd = opened.end;
    const operators = { ...this.state.operators };
    lastKnown.forEach((position) => {
      const next = buildOperatorMapState([position], [], new Date())[
        position.operator
      ];
      if (!next) return;
      const previous = operators[position.operator];
      const trail = previous ? previous.last_posi_point : [];
      const segments =
        previous && previous.last_posi_segments && previous.last_posi_segments.length
          ? previous.last_posi_segments
          : trail.length
            ? [trail]
            : [];
      const stamp = position.timestamp ? new Date(position.timestamp) : null;
      const inPeriod =
        stamp &&
        !Number.isNaN(stamp.getTime()) &&
        stamp >= tracePeriodStart &&
        stamp <= tracePeriodEnd;
      const nextSegments = inPeriod
        ? appendOperatorTrailSegments(segments, next.lastKnown)
        : segments;
      const nextTrail = flattenTrailSegments(nextSegments);

      operators[position.operator] = {
        ...(previous || {}),
        ...next,
        lastKnown: next.lastKnown,
        last_connection: next.last_connection,
        last_posi_point: nextTrail,
        last_posi_segments: nextSegments,
        lastMovedAt: nextLastMovedAt({
          previousMovedAt: previous && previous.lastMovedAt,
          previousPosition: previous && previous.lastKnown,
          nextPosition: next.lastKnown,
          fallbackAt: next.last_connection,
        }),
      };
    });

    this.setState((prev) => ({
      operators,
      ...(opened.followsNow
        ? { tracePeriodStart, tracePeriodEnd }
        : {}),
      parkedMachines: rememberParkedMachines(
        prev.parkedMachines,
        prev.telemetrySessions,
        operators
      ),
    }));
  };

  async loadDashboardTraces(options = {}) {
    const quiet = options.quiet === true;
    const requestId = (this._tracesRequestId || 0) + 1;
    this._tracesRequestId = requestId;
    const {
      equipment,
      selectedLandplots,
      trailDayKeys = [],
    } = this.state;
    const now = new Date();
    // Chips ligadas mandam no período (união 1h/12h/dias); senão, 1h/12h “ao vivo”.
    const fromKeys =
      (trailDayKeys || []).length > 0
        ? periodForTrailDayKeys(trailDayKeys, now)
        : null;
    const opened = fromKeys
      ? { start: fromKeys.start, end: fromKeys.end, followsNow: true }
      : openTracePeriod(
          this.state.tracePeriodStart,
          this.state.tracePeriodEnd,
          now
        );
    const tracePeriodStart = opened.start;
    const tracePeriodEnd = opened.end;
    const fenceSelected = (selectedLandplots || []).length > 0;
    const peopleMonth = this.state.mapTrailMode === "people";
    const validationError = validateTracePeriod(
      tracePeriodStart,
      tracePeriodEnd,
      {
        maxMs: peopleMonth
          ? MAX_PEOPLE_TRACE_PERIOD_MS
          : fenceSelected
            ? MAX_FENCE_TRACE_PERIOD_MS
            : MAX_TRACE_PERIOD_MS,
      }
    );

    if (validationError) {
      if (!quiet) this.setState({ traceError: validationError });
      return;
    }

    const machineIds = Object.keys(equipment).map((id) => parseInt(id, 10));

    if (!quiet) {
      this.setState({
        traceLoading: true,
        traceError: "",
        traceMode: "historical",
        ...(fromKeys
          ? {
              tracePeriodStart,
              tracePeriodEnd,
              tracePresetHours: Math.max(
                1,
                Math.round((tracePeriodEnd - tracePeriodStart) / (60 * 60 * 1000))
              ),
            }
          : {}),
      });
      this.loadTrailOperations();
    } else if (!(this.state.trailOperations || []).length) {
      this.loadTrailOperations();
    }

    this._traceRefreshInFlight = true;
    try {
      const lastKnown = await this.fetchOperatorLastKnown();
      if (this._unmounted || this._tracesRequestId !== requestId) return;
      const trailPositions = (
        await this.fetchOperatorTrailPositions(tracePeriodStart, tracePeriodEnd)
      )
        .filter((position) =>
          stampOnTrailDays(
            position && (position.timestamp || position.time),
            trailDayKeys,
            now
          )
        )
        .filter((position) =>
        pointInsideLandplots(
          {
            lat:
              position && position.latitude != null
                ? position.latitude
                : position && position.lat,
            lng:
              position && position.longitude != null
                ? position.longitude
                : position && position.lng,
          },
          selectedLandplots
        )
      );
      if (this._unmounted || this._tracesRequestId !== requestId) return;
      const operators = buildOperatorMapState(
        lastKnown,
        trailPositions,
        new Date()
      );
      if (this._unmounted || this._tracesRequestId !== requestId) return;
      if (!(quiet && trailPositions.length === 0)) {
        this.setState({ operators });
      }

      const dt_ini = getFormatedDate(tracePeriodStart);
      const dt_end = getFormatedDate(tracePeriodEnd);
      const landplotIds = (selectedLandplots || []).map((plot) => plot.id).join(",");
      const insideOnly = fenceSelected ? "false" : "true";
      const pathResponse =
        machineIds.length > 0
          ? await axios({
              baseURL: `${myConfig.API_URL}/equipment/path_report/?farm_id=${this.farmId}&eq=${machineIds}&dt_ini=${dt_ini}&dt_end=${dt_end}&ldps=${landplotIds}&in_ldp=true&out_ldp=${insideOnly}`,
              method: "GET",
              headers: this.operatorAuthHeaders(),
            })
          : { data: [] };

      if (this._unmounted || this._tracesRequestId !== requestId) return;

      const traces = flattenPathReportToTraces(pathResponse.data, equipment);
      const emptyTrailMessage = this.props.t
        ? this.props.t(
            "Nenhum rastro GPS no período selecionado. Máquinas e operadores permanecem no último ponto conhecido."
          )
        : "Nenhum rastro GPS no período selecionado. Máquinas e operadores permanecem no último ponto conhecido.";

      this.setState((prev) => {
        const updatedEquipment = { ...prev.equipment };
        let loadedPoints = countTracePoints(
          quiet && trailPositions.length === 0 ? prev.operators : operators
        );

        Object.keys(updatedEquipment).forEach((id) => {
          const historicalPoints = (traces[id] || []).filter((point) =>
            stampOnTrailDays(point && point.time, trailDayKeys, now)
          );
          const current = prev.equipment[id] || {};
          const currentPoints = current.last_posi_point || [];
          const livePoint = lastValidCoordinate(currentPoints);

          if (historicalPoints.length > 0) {
            loadedPoints += historicalPoints.length;
            updatedEquipment[id] = {
              ...current,
              last_posi_point: appendMovedPoint(
                [...historicalPoints],
                livePoint
              ),
            };
            return;
          }

          if (quiet) {
            return;
          }

          if (livePoint) {
            updatedEquipment[id] = {
              ...current,
              last_posi_point: [livePoint],
            };
          }
        });

        return {
          equipment: updatedEquipment,
          ...(opened.followsNow ? { tracePeriodStart, tracePeriodEnd } : {}),
          traceLoading: quiet ? prev.traceLoading : false,
          historicalTracesLoaded: true,
          traceError: quiet || loadedPoints > 0 ? "" : emptyTrailMessage,
        };
      });
    } catch (error) {
      const apiMessage =
        error &&
        error.response &&
        error.response.data &&
        (error.response.data.detail || error.response.data.message);

      if (this._unmounted || this._tracesRequestId !== requestId || quiet) return;
      this.setState({
        traceLoading: false,
        traceError:
          typeof apiMessage === "string" && apiMessage
            ? apiMessage
            : "Falha ao carregar rastros históricos. Verifique o período e tente novamente.",
      });
    } finally {
      if (this._tracesRequestId === requestId) {
        this._traceRefreshInFlight = false;
      }
    }
  }

  load_kpi_data() {
    axios({
      baseURL: this.FARM_URL,
      method: "get",
      timeout: 15000,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
    }).then((res) => {
      let farm = res.data;

      if (res.status === 200) {
        this.setState({
          farm,
          loading: false,
          map: {
            centroidLat: String(farm.latitude || "").replace(",", "."),
            centroidLng: String(farm.longitude || "").replace(",", "."),
          },
        });

        this.fetchKpis();
      } else {
        this.setState({
          loading: false,
          errors: this.state.errors.concat(getErrorComponent(res.data.detail)),
        });
      }
    }).catch(() => {
      if (this._unmounted) return;
      this.setState({ loading: false });
    });
  }

  loadTrailOperations = async () => {
    const { tracePeriodStart, tracePeriodEnd } = this.state;
    if (!this.farmId || !tracePeriodStart || !tracePeriodEnd) return;
    const requestId = (this._trailOpsRequest || 0) + 1;
    this._trailOpsRequest = requestId;
    const from = new Date(tracePeriodStart.getTime() - 31 * 24 * 60 * 60 * 1000);
    const params = new URLSearchParams({
      farm_id: String(this.farmId),
      dt_ini__gte: from.toISOString(),
      dt_ini__lte: new Date(tracePeriodEnd).toISOString(),
    });
    try {
      const response = await axios({
        baseURL: `${myConfig.API_URL}/operation/?${params.toString()}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      });
      if (this._unmounted || this._trailOpsRequest !== requestId) return;
      const data = Array.isArray(response.data)
        ? response.data
        : (response.data && response.data.results) || [];
      this.setState({ trailOperations: data });
    } catch (error) {
      if (this._unmounted || this._trailOpsRequest !== requestId) return;
    }
  };

  async loadOperations() {
    try {
      const URL = `${myConfig.API_URL}/operation/?farm_id=${this.farmId}&fineshed=0`;

      let response = await axios({
        baseURL: URL,
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      });

      let data = response.data;

      this.setState({
        operations: data,
      });
    } catch (e) {
      let error_msg =
        "Falha ao carregar operações, recarregue a página e tente novamente";

      alert(error_msg);
    }
  }

  async componentWillMount() {
    //GTM

    //KPI's
    await this.load_kpi_data();
    // landplot
    this.load_landplot_data();
    // markers
    this.load_markers_data();
    this.loadTelemetrySessions();
    // operations
    this.loadOperations();

    document.title = "Agriconnected - Painel";
  }

  load_map() {
    let {
      mapZoom,
      marker_center,
      map,
      landplot,
      farm,
      equipment,
      operators,
      telemetrySessions,
      telemetryReleases,
      modal,
      modalOperation,
      modalHoursIdle,
      tracePanelOpen,
      tracePresetHours,
      traceLoading,
      traceError,
    } = this.state;

    const { cleanMode, mapHeight } = this.state;
    const tracedOperators = {};
    const liveOperatorsBase = applySessionLastMachine(
      applyIconMachinePairing(
        attachActiveTelemetryOperators(
          operators,
          equipment,
          telemetrySessions
        ),
        telemetryReleases
      ),
      telemetrySessions
    );
    Object.keys(liveOperatorsBase || {}).forEach((id) => {
      const operator = liveOperatorsBase[id];
      const segments =
        operator.last_posi_segments && operator.last_posi_segments.length
          ? operator.last_posi_segments
          : (operator.last_posi_point || []).length
            ? [operator.last_posi_point]
            : [];
      const nextSegments = appendOperatorTrailSegments(
        segments,
        operator.lastKnown
      );
      tracedOperators[id] = {
        ...operator,
        last_posi_segments: nextSegments,
        last_posi_point: flattenTrailSegments(nextSegments),
      };
    });
    const liveOperators = tracedOperators;
    const liveEquipment = applyParkedMachinePositions(
      applyLiveTelemetryToAssumedMachines(equipment, liveOperators, {
        keepMachinePath: (this.state.trailDayKeys || []).length > 0,
      }),
      this.state.parkedMachines
    );
    const operatorsWithRelease = {};
    Object.keys(liveOperators || {}).forEach((id) => {
      const operator = liveOperators[id];
      operatorsWithRelease[id] = {
        ...operator,
        ...releaseFieldsFromEntry(
          telemetryReleases[operatorTelemetryReleaseKey(operator && operator.id)]
        ),
      };
    });
    const equipmentWithRelease = {};
    Object.keys(liveEquipment || {}).forEach((id) => {
      const equip = liveEquipment[id];
      const liveTip = equip && (equip.liveLastKnown || equip.parkedPosition);
      equipmentWithRelease[id] = {
        ...equip,
        last_posi_point: appendMovedPoint(equip && equip.last_posi_point, liveTip),
        ...releaseFieldsFromEntry(
          telemetryReleases[machineTelemetryReleaseKey(equip && equip.ident)]
        ),
      };
    });

    return (
      <>
      {cleanMode ? null : (
        <div className="dashboard-timezone-bar">
          <FieldAppTimezoneToggle
            mode={this.state.timezoneMode}
            onModeChange={this.handleTimezoneModeChange}
            t={this.props.t}
            showClock
          />
          <MapIconColorLegend placement="bar" />
          <DashboardTraceColorControl
            t={this.props.t}
            mode={this.state.traceColorMode}
            speeds={this.state.traceSpeeds}
            activeSpeedIndex={this.state.traceSpeedIndex}
            onModeChange={this.handleTraceColorMode}
            onSpeedSelect={this.handleTraceSpeedSelect}
            onSpeedChange={this.handleTraceSpeedChange}
          />
          <DashboardTracePanel
            t={this.props.t}
            open={tracePanelOpen}
            onToggle={this.handleTracePanelToggle}
            onPresetHours={this.handleTracePresetHours}
            activePresetHours={tracePresetHours}
            traceLoading={traceLoading}
            traceError={traceError}
            machineCount={Object.keys(equipment).length}
            operatorCount={Object.keys(operators).length}
            pointCount={
              countTracePoints(equipment) + countTracePoints(operators)
            }
            selectedLandplots={this.state.selectedLandplots}
            onClearLandplots={this.handleClearLandplots}
            landplotPickMode={this.state.landplotPickMode}
            onToggleLandplotPickMode={this.handleToggleLandplotPickMode}
          />
          <DashboardQuickMeasure
            t={this.props.t}
            map={this.state.nativeMap}
            maps={this.state.nativeMaps}
            farmId={this.farmId}
            lines={linesForQuickMeasure(
              equipmentWithRelease,
              operatorsWithRelease
            )}
            landplotPickMode={this.state.landplotPickMode}
            onToggleLandplotPickMode={this.handleToggleLandplotPickMode}
          />
        </div>
      )}
      <div
        className={cleanMode ? "map-container is-clean" : "map-container"}
        style={{
          height: cleanMode ? "100vh" : mapHeight,
          minHeight: cleanMode ? "100vh" : mapHeight,
        }}
      >
        <DashboardMapOrders>
        {(serviceOrders, refreshServiceOrders) => (
        <MapContainer
          zoomChanged={this.onZoomChanged}
          mapZoom={mapZoom}
          marker_center={marker_center}
          map={map}
          equipments={equipmentWithRelease}
          operators={operatorsWithRelease}
          assumedMachineIdents={assumedMachineIdentSet(
            telemetrySessions,
            liveOperators
          )}
          farm={farm}
          handleLoaded={this.handleMapLoaded}
          landplot={landplot}
          selectedLandplotIds={(this.state.selectedLandplots || []).map(
            (plot) => plot.id
          )}
          landplotPickMode={this.state.landplotPickMode}
          onToggleLandplot={this.handleToggleLandplot}
          farm_id={this.farmId}
          mapHeight={mapHeight}
          cleanMode={cleanMode}
          onSaveViewportExtra={this.persistMapHeight}
          onMapCenterChanged={this.handleMapCenterChanged}
          onViewportActionsReady={this.handleViewportActionsReady}
          timezoneMode={this.state.timezoneMode}
          traceColorMode={this.state.traceColorMode}
          traceSpeedKmh={this.state.traceSpeedKmh}
          operatorTraceColors={this.state.operatorTraceColors}
          mapTrailMode={this.state.mapTrailMode}
          visibleTrailOperatorIds={
            this.state.mapTrailMode === "active"
              ? this.state.activeTelemetryOperatorIds
              : trailsToDraw(
                  this.state.trailRoster && this.state.trailRoster.operatorIds,
                  this.state.visibleTrailOperatorIds
                )
          }
          visibleTrailMachineIdents={trailsToDraw(
            this.state.trailRoster && this.state.trailRoster.machineIdents,
            this.state.visibleTrailMachineIdents
          )}
          showIconLegend={cleanMode}
          onNativeMapReady={this.handleNativeMapReady}
          t={this.props.t}
          serviceOrders={serviceOrders}
          onServiceOrdersChanged={refreshServiceOrders}
          trailOperations={mergeTrailOperations(
            this.state.trailOperations,
            this.state.operations
          )}
        />
        )}
        </DashboardMapOrders>
        <DashboardHourlyForecastBar
          farm={farm}
          mapCenter={this.state.weatherCenter}
          onWindChange={this.handleWindChange}
        />
        <DashboardDailyForecastColumn
          farm={farm}
          mapCenter={this.state.weatherCenter}
        />
        <DashboardWindArrow windDeg={this.state.windDeg} />
        {cleanMode ? null : (
          <div className="dashboard-map-hud dashboard-map-hud--save">
            <button
              type="button"
              className="dashboard-hud-icon-btn"
              onClick={this.handleSaveMapViewportClick}
              title={this.props.t("Salvar posição do mapa")}
            >
              <FaMapMarkedAlt style={{ marginRight: 6 }} />
              {this.props.t("Salvar posição do mapa")}
            </button>
          </div>
        )}
        <div className="dashboard-map-hud dashboard-map-hud--expand">
          <button
            type="button"
            className="dashboard-hud-icon-btn"
            onClick={this.toggleCleanMode}
            title={
              cleanMode
                ? this.props.t("Sair da tela limpa")
                : this.props.t("Tela limpa")
            }
          >
            {cleanMode ? <FaCompress /> : <FaExpand />}
          </button>
        </div>
        {cleanMode ? null : (
          <div
            className="map-container-resize"
            title={this.props.t("Arraste para ampliar o mapa")}
            onMouseDown={this.handleMapHeightResize}
          />
        )}
        <div className="modal-list-machines-web">
          {modal && (
            <div className="x_panel">
              {this.renderMachines()}

              <Link
                to={`/${this.farmId}/equipment/machine/add/`}
                className="btn btn-kpi-add"
              >
                {" "}
                <FaPlus size={20} />{" "}
              </Link>
            </div>
          )}
        </div>

        <div className="modal-list-operations-web">
          {modalOperation && (
            <>
              <div className="x_panel">
                {this.renderOperations()}

                <Link
                  to={`/${this.farmId}/operation/add/`}
                  className="btn btn-kpi-add"
                >
                  {" "}
                  <FaPlus size={20} />{" "}
                </Link>
              </div>
            </>
          )}
        </div>

        <div className="modal-list-machine-idle-web">
          {modalHoursIdle && (
            <>
              <div className="x_panel">{this.renderMachinesIdle()}</div>
            </>
          )}
        </div>
      </div>
      </>
    );
  }

  renderMachinesIdle() {
    let { periods, period_id } = this.state;

    return (
      <div className="table-machines-idle">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>{this.props.t("Identificação")}</th>
              <th>{this.props.t("Tempo ocioso")}</th>
            </tr>
          </thead>
          <tbody>
            {periods[period_id].equipments.map((item) => (
              <tr key={item.name}>
                <td scope="row">{item.equipment_name}</td>
                <td>{item.hours}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderMachines() {
    const { equipment } = this.state;

    return (
      <>
        <ul className="list-group list-machines-with-link">
          {Object.keys(equipment).map((item) => {
            return (
              <li
                className="list-group-item d-flex justify-content-between align-items-center"
                key={equipment[item].id}
              >
                <Link
                  to={`/${this.farmId}/equipment/machine/${equipment[item].id}/report`}
                  className="machine-link-detail"
                >
                  <strong>{equipment[item].ident}</strong>
                </Link>
              </li>
            );
          })}
        </ul>
      </>
    );
  }

  renderOperations() {
    const { operations } = this.state;

    return (
      <>
        <ul className="list-group list-operations-with-link">
          {operations.map((item) => {
            return (
              <li
                className="list-group-item d-flex justify-content-between align-items-center"
                key={item.id}
              >
                <Link
                  to={`/${this.farmId}/operation/${item.id}/progress/`}
                  className="machine-link-detail"
                >
                  <strong>{item.ident}</strong>
                </Link>
              </li>
            );
          })}
        </ul>
      </>
    );
  }

  get_content() {
    let { modal, modalOperation, modalHoursIdle } = this.state;

    return (
      <>
        <div className="modal-list-machine-idle-mobile">
          {modalHoursIdle && (
            <>
              <div className="x_panel-idle-mobile">
                {this.renderMachinesIdle()}
              </div>
            </>
          )}
        </div>
        <div className="modal-list-operations-mobile">
          {modalOperation && (
            <div className="x_panel-operations-mobile">
              {this.renderOperations()}

              <Link
                to={`/${this.farmId}/equipment/operation/add/`}
                className="btn btn-kpi-add"
              >
                {" "}
                <FaPlus size={20} />{" "}
              </Link>
            </div>
          )}
        </div>

        <div className="modal-list-machines-mobile">
          {modal && (
            <div className="x_panel-mobile">
              {this.renderMachines()}

              <Link
                to={`/${this.farmId}/equipment/machine/add/`}
                className="btn btn-kpi-add"
              >
                {" "}
                <FaPlus size={20} />{" "}
              </Link>
            </div>
          )}
        </div>

        {this.load_map()}
      </>
    );
  }

  showPopup() {
    let client = null;
    try {
      client = JSON.parse(localStorage.client);
    } catch (error) {
      return null;
    }

    if (client && client.accepted_terms !== true) {
      return <PoupUp user_id={client.id} farm_id={this.farmId} />;
    }
    return null;
  }

  displayKpis() {
    let { kpi_data, periods, period_id } = this.state;
    const kpisReady = Boolean(kpi_data && kpi_data.operation_status);

    return (
      <div className="row tile_count ind-container">
        {!kpisReady ? (
          <>
            <div className="col-xs-12 col-md-3 col-lg-3 col-sm-6 ">
              <div className="x_panel no-margin-top animate"></div>
            </div>
            <div className="col-xs-12 col-md-3 col-lg-3 col-sm-6 ">
              <div className="x_panel no-margin-top animate"></div>
            </div>{" "}
            <div className="col-xs-12 col-md-3 col-lg-3 col-sm-6 ">
              <div className="x_panel no-margin-top animate"></div>
            </div>{" "}
            <div className="col-xs-12 col-md-3 col-lg-3 col-sm-6 ">
              <div className="x_panel no-margin-top animate"></div>
            </div>
          </>
        ) : (
          <KpisGadgets
            periods={periods}
            period_id={period_id}
            kpi={kpi_data}
            farm_id={this.farmId}
            operatorTraceColors={this.state.operatorTraceColors}
            onOperatorTraceColorChange={this.handleOperatorTraceColor}
            operators={this.state.operators}
            equipment={this.state.equipment}
            visibleTrailOperatorIds={this.state.visibleTrailOperatorIds}
            visibleTrailMachineIdents={this.state.visibleTrailMachineIdents}
            trailRoster={this.state.trailRoster}
            onChangeVisibleTrailOperators={this.handleVisibleTrailOperators}
            onChangeVisibleTrailMachines={this.handleVisibleTrailMachines}
            onChangeTrailRoster={this.handleTrailRoster}
            mapTrailMode={this.state.mapTrailMode}
            trailNoticeOpen={this.state.trailNoticeOpen}
            tracePeriodStart={this.state.tracePeriodStart}
            tracePeriodEnd={this.state.tracePeriodEnd}
            trailDayKeys={this.state.trailDayKeys}
            onToggleTrailDay={this.handleToggleTrailDay}
            onToggleTrailHour={this.handleToggleTrailHour}
            activeTraceHours={this.state.activeTraceHours}
            onSelectPeopleTrails={this.handleSelectPeopleTrails}
            onCloseTrailNotice={this.handleCloseTrailNotice}
            onApplyPeopleTrailPeriod={this.handleApplyPeopleTrailPeriod}
            onSelectActiveTrails={this.handleSelectActiveTrails}
            onActiveTraceHours={this.handleActiveTraceHours}
            onActiveTelemetrySessions={this.handleActiveTelemetrySessions}
            fieldAlertPrefs={this.state.fieldAlertPrefs}
            onChangeFieldAlertPrefs={this.handleFieldAlertPrefsChange}
            handleModal={this.handleModal}
            setPeriod={this.setPeriod}
            farm={this.state.farm}
            selectedLandplots={this.state.selectedLandplots}
            landplotPickMode={this.state.landplotPickMode}
            onToggleLandplotPickMode={this.handleToggleLandplotPickMode}
            handleModalOperation={this.handleModalOperation}
            handleModalHoursIdle={this.handleModalHoursIdle}
          />
        )}
      </div>
    );
  }

  render() {
    let { loading } = this.state;

    let PoupUp;
    let content;

    if (loading === false) {
      content = this.get_content();
      PoupUp = this.showPopup();
    } else {
      content = <ShimmerLoadingMap />;
    }

    const phoneScale = this.state.phoneScale;
    const desktopOnPhone = phoneScale < 0.999;

    return (
      <div
        className={
          desktopOnPhone ? "dashboard dashboard--desktop-on-phone" : "dashboard"
        }
        style={
          desktopOnPhone
            ? { width: PHONE_DESKTOP_WIDTH, zoom: phoneScale }
            : undefined
        }
      >
        {this.displayKpis()}

        {content}
        {PoupUp}
        <DashboardFieldAlertPopup
          event={this.state.fieldAlertCurrent}
          soundEnabled={this.state.fieldAlertPrefs.soundEnabled !== false}
          soundId={this.state.fieldAlertPrefs.soundId}
          volume={this.state.fieldAlertPrefs.volume}
        />
        <ToastContainer />
        <FloatingWhatsApp
          accountName="Agriconnected"
          phone="5511999061384"
          account="5511999061384"
          label="Fale conosco"
          backgroundColor="#25d366"
          position="right"
          initialMessageByServer="Olá, gostaria de falar com nosso suporte?"
          initialMessageByClient="Olá, poderia me ajudar?"
          statusMessage="Disponível"
          startChatText="Falar com suporte"
          tooltipText="Fale conosco"
          allowEsc={true}
        />
      </div>
    );
  }
}

function ShimmerLoadingMap() {
  return (
    <>
      <div className="shimmer-map-container animate"></div>
    </>
  );
}

export default withTranslation()(Home);
